export default __webpack_public_path__ + "sony-vegas.fa000c9e.png";